export const ItemTabData = [
  {
    name: 'Hats',
    icon: 'hattab',
    slot: 'hats',
  },
  {
    name: 'Hair',
    icon: 'hairtab',
    slot: 'hair',
  },
  {
    name: 'Face',
    icon: 'maskstab',
    slot: 'face',
  },
  {
    name: 'Tops',
    icon: 'topstab',
    slot: 'clothes',
  },
  {
    name: 'Bottoms',
    icon: 'pantstab',
    slot: 'pants',
  },
  {
    name: 'Back',
    icon: 'backtab',
    slot: 'back',
  },
  {
    name: 'Shoes',
    icon: 'shoestab',
    slot: 'shoes',
  },
  {
    name: 'Gloves',
    icon: 'glovestab',
    slot: 'gloves',
  },
];
